import { render, staticRenderFns } from "./allApplication.vue?vue&type=template&id=0ba51810&scoped=true"
import script from "./allApplication.vue?vue&type=script&lang=js"
export * from "./allApplication.vue?vue&type=script&lang=js"
import style0 from "./allApplication.vue?vue&type=style&index=0&id=0ba51810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba51810",
  null
  
)

export default component.exports